import { DiscountRestriction } from '@vista-digital/ocapi-types/v1';
import { getOrderVoucherRedemptionDetails } from '../../order/selectors/vouchers/get-order-voucher-redemption-details';
import { getOrderVouchersForTypeCodes } from '../../order/selectors/vouchers/get-order-vouchers-for-type-codes';
export const isVoucherDiscountAvailable = (voucherTypeCodes) => {
    const vouchers = getOrderVouchersForTypeCodes(voucherTypeCodes);
    return vouchers.some(voucher => getOrderVoucherRedemptionDetails(voucher.id).availableRedemptions > 0);
};
export const isVoucherDiscount = (discount) => discount.restrictions.includes(DiscountRestriction.Voucher);
//# sourceMappingURL=voucher-utils.js.map